import { lazyLoad } from 'utils/loadable';

export const LazyPromptInstall = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'installPrompt', webpackPrefetch: true */ './PromptInstall'
    ),
  module => module.default,
  { fallback: null },
);
